export default "__VITE_ASSET__66801897__"